// import TrackingPage from 'src/views/dexp/tracking/TrackingPageAdvanced'
import TrackingPageWrapper from 'src/views/dexp/tracking'
import pathMap from 'src/paths/pathMap'

class DexpRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.DEXP_TRACKING_PATH,
        component: TrackingPageWrapper
      }
    ]
  }
}

export default DexpRoute
